import { useParams } from 'react-router-dom';
import { useRemoveExercise } from '@features/exercises';
import { useExerciseEditFormPagesRedirect } from '@features/exercises/exercise-form/model/helpres.ts';
import { useMobile } from '@shared/hooks/index.ts';
import { useSaveScroll } from '@shared/hooks/use-save-scroll.ts';
import { DropdownItem, useMenuDropdown } from '@shared/ui';
import { DropdownMenuWithButton } from '@shared/ui/menus/dropdown-menu/index.ts';
import * as st from './styles.module.scss';

interface Props {
  videoId: number;
}

export const ListMenu: React.FC<Props> = ({ videoId }) => {
  const { menuRef, onClose, handleToggleDropdown, isMenuOpen } = useMenuDropdown({});
  const { doRedirectWithSavePageUrl } = useExerciseEditFormPagesRedirect();
  const { isMobile } = useMobile();
  const { code } = useParams<{ code: string }>();
  const { clearListScrollData } = useSaveScroll('ExerciseListScrollData');

  const onEdit = () => {
    clearListScrollData();
    doRedirectWithSavePageUrl(`/programs/${code}/exercise-edit/${videoId}`, {
      state: { isDisabledSelectionFromLibrary: true },
    });
  };

  const { removeExercise } = useRemoveExercise({ videoId });

  return (
    <DropdownMenuWithButton
      smallButton={!isMobile}
      isMenuOpen={isMenuOpen}
      onMenuBtnClick={handleToggleDropdown}
      menuRef={menuRef}
      buttonVariant={isMenuOpen ? 'activeDark' : isMobile ? 'white' : 'dark'}
      buttonClassName={st.moreBtn}
    >
      <DropdownItem
        onClick={(e) => {
          e.stopPropagation();
          onEdit();
          onClose();
        }}
      >
        Изменить
      </DropdownItem>

      <DropdownItem
        onClick={(e) => {
          e.stopPropagation();
          removeExercise();
          onClose();
        }}
      >
        Удалить
      </DropdownItem>
    </DropdownMenuWithButton>
  );
};
